import Chip from "./Chip";

interface IChipList {
  title: string;
  data?: string[];
  dataObj?: ILanguagesSpoken[];
}

interface ILanguagesSpoken {
  language: string;
  proficiency: string;
}

export default function ChipList({ title, data, dataObj }: IChipList) {
  return (
    <div className="chip-info-wrapper">
      <div className="text-pad-left">{title}</div>
      {data && (
        <div className="chip-wrapper">
          {data.map((each, key) => (
            <Chip key={key} text={each} />
          ))}
        </div>
      )}
      {dataObj && (
        <div className="chip-wrapper">
          {dataObj.map((each, key) => (
            <Chip key={key} text={each.language} />
          ))}
        </div>
      )}
    </div>
  );
}
